import { ref, onMounted, onUnmounted } from 'vue'

export function useOnlineStatus() {
  // สถานะปัจจุบันตอนนี้เลย
  const isOnline = ref(navigator.onLine)

  const updateStatus = () => {
    isOnline.value = navigator.onLine
  }

  onMounted(() => {
    window.addEventListener('online', updateStatus)
    window.addEventListener('offline', updateStatus)
  })

  onUnmounted(() => {
    window.removeEventListener('online', updateStatus)
    window.removeEventListener('offline', updateStatus)
  })

  // เผื่ออยากเช็คแบบเรียก function ทันที
  const checkNow = () => navigator.onLine

  return {
    isOnline,
    checkNow,
  }
}
